import { FileUtils } from "lib/utils/file-utils";
import { FC, useEffect, useState } from "react";
import { Button, Image } from "react-bootstrap";
import { PiTrashLight } from "react-icons/pi";
import FlexBox from "../flex-box";
import { ASSETS } from "assets";
import { getUniqueId, openUrlInNewTab } from "lib/utils/util";
import { DMSServices } from "lib/services/document-services";
import LoadingBox from "../loading-box";

const DocTypePreview = ({
  doc,
  onLoaded,
}: {
  doc: File;
  onLoaded?: VoidFunction;
}) => {
  const id = getUniqueId("simple-doc-upload-");

  if (doc.type.match("image.*")) {
    FileUtils.setImagePreview(doc, id);
    return (
      <Image
        id={id}
        className="w-100 h-100 rounded cursor-pointer"
        src={URL.createObjectURL(doc)}
        onLoad={onLoaded}
        onClick={() => {
          const url = URL.createObjectURL(doc);
          openUrlInNewTab(url);
        }}
      />
    );
  } else if (doc.type.match("video.*")) {
    return <Image src={""} onLoad={onLoaded} />;
  } else if (doc.type.match("audio.*")) {
    return <Image src={""} onLoad={onLoaded} />;
  } else {
    return (
      <Image
        id="simple-doc-upload-document-preview"
        className="w-100 h-100 rounded cursor-pointer"
        src={ASSETS.IMAGES.PDF_PLACEHOLDER}
        onLoad={onLoaded}
        onClick={() => {
          const url = URL.createObjectURL(doc);
          openUrlInNewTab(url);
        }}
      />
    );
  }
};

interface SimpleDocPreviewerProps {
  doc?: File;
  docUrl?: string;
  isShowRemoveButton?: boolean;
  onDelete?: () => void;
}

const SimpleDocPreviewer: FC<SimpleDocPreviewerProps> = ({
  doc,
  docUrl,
  isShowRemoveButton = true,
  onDelete,
}) => {
  const [currentDoc, setCurrentDoc] = useState<File | null>(doc);

  useEffect(() => {
    if (docUrl) {
      DMSServices.getDocumentFromUrl(docUrl).then((file) =>
        setCurrentDoc(file)
      );
    } else if (doc) {
      setCurrentDoc(doc);
    } else {
      setCurrentDoc(null);
    }
  }, [docUrl, doc]);

  // useEffect(() => {
  //   setCurrentDoc(doc);
  // }, [doc]);

  return (
    <div className={`doc-uploader rounded`}>
      {!currentDoc ? <LoadingBox /> : <DocTypePreview doc={currentDoc} />}

      {isShowRemoveButton && currentDoc && (
        <div
          className="d-grid gap-2"
          style={{
            display: "block",
            position: "relative",
            marginTop: "-36px",
          }}
        >
          <Button variant="primary" onClick={onDelete}>
            <FlexBox justifyContent="center" alignItems="center">
              <PiTrashLight size={18} />
              <>REMOVE</>
            </FlexBox>
          </Button>
        </div>
      )}
    </div>
  );
};

export default SimpleDocPreviewer;
